<template>
  <div
    class="white pa-4 d-flex align-center text-body-2 font-weight-light"
    @click="$emit('click')"
  >
    <upload-status-chip
      class="mr-2"
      :reference-files="uploadGroup.referenceFiles"
    />
    <div class="mr-1">
      <researcher-avatar :researcher="uploadGroup.researcher" small />
    </div>
    <span class="font-weight-bold mr-1">
      {{ uploadGroup.researcher.name }}
    </span>
    <span class="mr-2">uploaded {{ numberOfFilesText }}</span>
    <span class="grey--text">{{ time }}</span>
    <v-spacer />
    <action-button
      color="primary"
      class="mr-2"
      :loading="downloading"
      @click.native.stop="$emit('download-all')"
    >
      <v-icon left class="material-icons-outlined">download</v-icon>
      Download All
    </action-button>
    <action-button
      v-if="canDelete"
      color="error"
      class="mr-2"
      :loading="deleting"
      tooltip="Delete this upload group and every reference it added"
      @click.native.stop="$emit('delete')"
    >
      <v-icon left class="material-icons-outlined">delete</v-icon>
      Delete
    </action-button>
    <icon-button
      class="icon-button"
      :class="{ active }"
      icon="expand_more"
      size="x-small"
      color="grey lighten-3"
    />
  </div>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import IconButton from '@/components/Common/IconButton';
import UploadStatusChip from '@/components/UploadsPage/UploadStatusChip';
import ResearcherAvatar from '@/components/Common/ResearcherAvatar';
import { formatDistanceToNow } from 'date-fns';
import { UploadGroupDto } from '@/models';

export default {
  name: 'UploadGroupListItemHeader',
  components: {
    ActionButton,
    IconButton,
    UploadStatusChip,
    ResearcherAvatar,
  },
  props: {
    uploadGroup: {
      type: UploadGroupDto,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    downloading: {
      type: Boolean,
      default: false,
    },
    deleting: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click', 'download-all', 'delete'],
  computed: {
    time() {
      return formatDistanceToNow(this.uploadGroup.createdAt, {
        addSuffix: true,
      });
    },
    numberOfFilesText() {
      const { referenceFiles } = this.uploadGroup;
      const count = referenceFiles.length;
      return count === 1 ? '1 file' : `${count} files`;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-button {
  transition: transform 0.3s;

  &.active {
    transform: rotate(180deg);
  }
}
</style>
